export default __webpack_public_path__ + "static/media/ellipse_wallet_5.383026a2.svg";